import validator from 'validator';

export default function isGreaterOrEqual(values, value, other) {
  return validator.isInt(`${value || ''}`, { min: Number.parseInt(other) });
}
